import axios from "axios";
import {BASE_URL} from "../requests/APIConfig";

export const SearchBang = (params) => {
  // const url = `https://apistaging.jbcert.vn/api/Search/SearchBang`;
  const url = `${BASE_URL}/api/Search/SearchBang`;

  return axios(url, {
    method: "GET",
    withCredentials: true,
    params: {
      ...params,
    },
  });
};

export const SearchAdvanceBang = (params) => {
  // const url = `https://apistaging.jbcert.vn/api/Search/AdvancedSearch`;
  const url = `${BASE_URL}/api/Search/AdvancedSearch`;

  return axios(url, {
    method: "GET",
    withCredentials: true,
    params: {
      ...params,
    },
  });
};

export const Detail = (params) => {
  // const url = `https://apistaging.jbcert.vn/api/Search/Detail`;
  const url = `${BASE_URL}/api/Search/Detail`;

  return axios.get(url, {
    withCredentials: true,
    params: {
      ...params,
    },
  });
};

export const GetCapCha = (params) => {
  // const url = `https://apistaging.jbcert.vn/api/Captcha/GetCaptcha`;
  const url = `${BASE_URL}/api/Captcha/GetCaptcha`;

  return axios.get(url, {
    responseType: "arraybuffer",
    params: {
      ...params,
    },
    withCredentials: true,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Cache: "no-cache",
      credentials: "same-origin",
    },
  });
};

// return axios(`https://apistaging.jbcert.vn/api/Search/SearchBang`, {
//     method: "GET",
//     withCredentials: true,
//     headers: {
//       "Content-Type": "application/json",
//       "Access-Control-Allow-Credentials": `true`,
//     },
//     // data: {
//     //   ...params,
//     // },
//     params: {
//       ...params,
//     },
//   });
